import * as React from "react";

export interface IInstructionsMap {
  value: {
    [lang: string]: string;
  };
}
export interface IWithInstructions {
  instructionsKey?: string;
  isTranslationKey: boolean;
  setInstructions: (newKey?: string, isTranslationKey?: boolean, newInstructionsMap?: IInstructionsMap) => void;

  instructionsMap: IInstructionsMap;
}
interface IProviderProps {
  children: React.ReactNode;
}

const InstructionsContext = React.createContext<IWithInstructions>({
  instructionsKey: undefined,
  isTranslationKey: true,
  setInstructions: (newKey?: string): void => {
    return;
  },
  instructionsMap: {
    value: {
      EN: ""
    }
  }
});

export const InstructionsProvider = ({ children }: IProviderProps) => {
  const [{ translationKey, isTranslationKey, instructionsMap }, setTranslationKey] = React.useState<{
    isTranslationKey: boolean;
    translationKey?: string;
    instructionsMap: IInstructionsMap;
  }>({
    isTranslationKey: true,
    translationKey: undefined,
    instructionsMap: { value: { EN: "" } }
  });

  const updateTranslationKey = React.useCallback(
    (newKey?: string, newIsTranslationKey = true, newInstructionsMap = { value: { EN: "" } }) => {
      setTranslationKey({
        isTranslationKey: newIsTranslationKey,
        translationKey: newKey,
        instructionsMap: newInstructionsMap
      });
    },
    []
  );

  const context: IWithInstructions = React.useMemo(
    () => ({
      instructionsKey: translationKey,
      isTranslationKey,
      setInstructions: updateTranslationKey,
      instructionsMap
    }),
    [translationKey, isTranslationKey]
  );

  return <InstructionsContext.Provider value={context}>{children}</InstructionsContext.Provider>;
};

export const withInstructions = <P extends object>(Component: React.ComponentType<P>) => (props: P) => {
  return (
    <InstructionsContext.Consumer>
      {({ instructionsKey, setInstructions, isTranslationKey, instructionsMap }) => {
        const newProps = {
          ...props,
          instructionsKey,
          isTranslationKey,
          setInstructions,
          instructionsMap
        };
        return <Component {...(newProps as P)} />;
      }}
    </InstructionsContext.Consumer>
  );
};
